import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {SelectField} from 'hateoas-navigator';

@Component({
  selector: 'app-select-field',
  template: `<mat-form-field class="cmp-full-width">
  <mat-select [placeholder]="field.getTitle()" [formControl]="control">
    <mat-option *ngFor="let option of field.getOptions()" [value]="option">
      {{ option }}
    </mat-option>
  </mat-select>
</mat-form-field>
`,
  styles: [`.cmp-full-width{width:100%}`]
})
export class SelectFieldComponent {
  @Input()
  field: SelectField;

  @Input()
  control: FormControl;
}
